import { createGlobalStyle } from 'styled-components';
import tooltipStyles from 'react-tippy/dist/tippy.css';

export default createGlobalStyle`
	${tooltipStyles};
`;
